import React, { useState } from 'react';
import { useAbdm } from '../context/AbdmContext';
import { handleLogin } from '../../utils/api';

export const LoginForm: React.FC = () => {
    const { state, dispatch } = useAbdm();
    const { loginData } = state;
    const [loginLoading, setLoginLoading] = useState(false);
    const [loginError, setLoginError] = useState('');

    const onLogin = async () => {
        setLoginLoading(true);
        setLoginError('');
        try {
            const authData = await handleLogin(loginData);
            dispatch({ type: 'SET_AUTH_DATA', payload: authData });
            dispatch({ type: 'SET_STEP', payload: 'authType' });
            localStorage.setItem('abdm_auth_data', JSON.stringify(authData));
        } catch (error) {
            setLoginError((error as Error).message);
        } finally {
            setLoginLoading(false);
        }
    };

    return (
        <div className="step-container">
            <h2>Organization Login</h2>
            <div className="form-group">
                <label htmlFor="username">Username</label>
                <input
                    id="username"
                    type="text"
                    value={loginData.username}
                    onChange={(e) => dispatch({ type: 'SET_LOGIN_DATA', payload: { ...loginData, username: e.target.value } })}
                    placeholder="Enter username"
                />
            </div>
            <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                    id="password"
                    type="password"
                    value={loginData.password}
                    onChange={(e) => dispatch({ type: 'SET_LOGIN_DATA', payload: { ...loginData, password: e.target.value } })}
                    placeholder="Enter password"
                />
            </div>
            <button onClick={onLogin} disabled={loginLoading} className="btn-primary">
                {loginLoading ? '🔐 Logging in...' : '🔐 Login to Organization'}
            </button>
            {loginError && <div className="error-message">Error: {loginError}</div>}
        </div>
    );
};